import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const removeStudentFromPerformanceAPI = async (
  actId: string,
  performanceId: string,
  studentId: string,
) => {
  await baseAPI.delete(
    `/acts/${actId}/performances/${performanceId}/students/${studentId}`,
  );
};

export const useRemoveStudentFromPerformanceMutation = () => {
  return useMutation({
    mutationFn: async ({
      actId,
      performanceId,
      studentId,
    }: {
      actId: string;
      performanceId: string;
      studentId: string;
    }) => {
      await removeStudentFromPerformanceAPI(actId, performanceId, studentId);
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACTS, variables.actId, KEYS.PERFORMANCES],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PERFORMANCES, variables.performanceId],
      });
    },
  });
};
